module.exports = __webpack_public_path__ + "static/media/otter.83151818.png";